import { useStoredList } from "@/hooks/useStoredList";

const STORAGE_KEY = "youyin_favorites";
const CHANGE_EVENT = "youyin-favorites-change";

export function useFavorites() {
  const { items, toggle, has } = useStoredList(STORAGE_KEY, CHANGE_EVENT);

  return {
    favorites: items,
    toggleFavorite: toggle,
    isFavorite: has,
  };
}